import React from "react";
import contextProvider from "../../contextProvider";
import { LinkContainer } from "react-router-bootstrap";
import { withRouter, Link } from "react-router-dom";
import { Row, Col, ButtonGroup } from "reactstrap";
import classnames from "classnames";
import ReactOActionBar from "../../_L1_components/Elements/ReactOActionBar";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import Panel from "../../_L1_components/Layout/Panel";
import Section from "../../_L1_components/Layout/Section";
import ReactOTable from "../../_L1_components/Elements/ReactOTable";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";

class MeasureBssidsList extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      currFreq: "all",
    };
    super(props, initState);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    if (this.getAppContext().getLocalStorageService().get("goBackExplorer")) {
      this.getAppContext().getLocalStorageService().remove("goBackExplorer");
    }
    // console.log(
    //   "DEBUG :: MeasureBssidsList _ onComponentDidMount",
    //   this.getAppContext().getApiStoreService().getCluster()
    // );
    // this.apiStore = this.getAppContext().getApiStoreService();
    //	this.loadProbeUsers();
  }

  onComponentWillUnmount() {
    //		console.log("DEBUG :: MeasureBssidsList _ onComponentWillUnmount");
  }

  removeInitialWeb(str) {
    if (str.startsWith("/web")) {
      return str.slice(4);
    }
    return str;
  }

  parseErr(err) {
    let word = err.substring(3, err.length);
    if (word == "DISCEARLY") {
      return <div>(AP Drop)</div>;
    } else {
      return <div>{`(${word})`}</div>;
    }
  }

  onRender() {
    return this.props.data ? (
      <div>
        <Panel
          className="mx-4 mb-3"
          bodyClassName="p-0"
          rounded
          header={
            "OVERALL INFORMATION ON " +
            (/ethernet/i.test(this.props.data.essid) ? "NETWORK" : "ESSID")
          }
        >
          {this.props.data.overalData ? (
            <Row noGutters>
              <LinkContainer
                onClick={() => {
                  let goBackExplorerURL = this.removeInitialWeb(
                    window.location.pathname
                  );

                  this.getAppContext()
                    .getLocalStorageService()
                    .set("goBackExplorer", goBackExplorerURL);
                }}
                to={{
                  pathname:
                    "/" +
                    this.props.match.params.probeuid +
                    "/" +
                    this.props.match.params.status +
                    "/" +
                    this.props.data.cssid +
                    "/overal/",
                }}
              >
                <a
                  href={
                    "/" +
                    this.props.match.params.probeuid +
                    "/" +
                    this.props.match.params.status +
                    "/" +
                    this.props.data.cssid +
                    "/overal/"
                  }
                  className={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? "mx-auto"
                      : ""
                  }
                >
                  <Col className={"d-flex flex-column p-3"}>
                    <div className="d-flex h-100 align-items-center">
                      {this.props.data.overalData.ImgName ? (
                        <img
                          src={
                            this.getAppContext()
                              .getApiStoreService()
                              .getCluster() +
                            "/RRDgrcache/" +
                            this.props.data.overalData.ImgName
                          }
                          className="border border-1 rounded"
                          alt="graph"
                        />
                      ) : (
                        <span>...</span>
                      )}
                    </div>
                  </Col>
                </a>
              </LinkContainer>

              {this.getAppContext().media.isMobile ||
              this.getAppContext().media.isTablet ? (
                <Col xs={12} />
              ) : null}

              <Col>
                <Section
                  className={
                    !this.getAppContext().media.isMobile &&
                    !this.getAppContext().media.isTablet
                      ? "border-top border-gray300"
                      : ""
                  }
                  designType="wide"
                  layoutManager="grid"
                  elementsPerRow={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                      ? 2
                      : !/ethernet/i.test(this.props.data.essid)
                      ? 5
                      : this.getAppContext().isCloud()
                      ? 5
                      : 4
                  }
                  gridSpacing={1}
                  gridSpacingColor={this.getAppContext().colors.gray300}
                  noColFirst={this.getAppContext().isCloud()}
                >
                  {!/ethernet/i.test(this.props.data.essid) ? (
                    <div className="border-left border-gray300 d-flex flex-column p-3">
                      <small className="text-muted mb-2">
                        <strong>BSSIDs</strong>
                      </small>
                      <div className="d-flex h-100 align-items-center">
                        <h4>
                          {this.props.data.dataPerBssid
                            ? this.props.data.dataPerBssid.length
                            : "--"}
                        </h4>
                      </div>
                    </div>
                  ) : this.getAppContext().isCloud() ? (
                    <div className="border-left border-gray300 d-flex flex-column p-3">
                      <small className="text-muted mb-2">
                        <strong>DIAGNOSTICS</strong>
                      </small>
                      <div
                        id="tp_overall_diag"
                        className="d-flex h-100 align-items-center"
                      >
                        {/* <ReactOTooltip
                          placement="bottom"
                          target="tp_overall_diag"
                          text={
                            this.props.data.dataPerBssid.length > 0
                              ? this.props.data.dataPerBssid[0].diagnostics
                                  .term == 2
                                ? "(On previous 4h)"
                                : "(On last period)"
                              : "-"
                          }
                        /> */}

                        {this.props.data?.dataPerBssid?.length > 0 &&
                        this.props.data.dataPerBssid[0].diagnostics &&
                        this.props.data.dataPerBssid[0].diagnostics
                          .last_state ? (
                          this.props.data.dataPerBssid[0].diagnostics
                            .last_state == "N" &&
                          this.props.data.connection_criteria == "RJ45" ? (
                            <span className="text-gray600">
                              <h4>Not enough data</h4>
                              <div className="sub-title">
                                since{" "}
                                {this.props.data.dataPerBssid[0].diagnostics
                                  .last_state_ts
                                  ? this.getAppContext()
                                      .momentjs(
                                        this.props.data.dataPerBssid[0]
                                          .diagnostics.last_state_ts,
                                        "X"
                                      )
                                      .format("L LT")
                                  : "-"}
                              </div>
                            </span>
                          ) : (
                            <span
                              className={
                                this.props.data.dataPerBssid[0].diagnostics
                                  .last_state == "N" ||
                                this.props.data.dataPerBssid[0].diagnostics
                                  .last_state == "U"
                                  ? "text-" +
                                    this.getAppContext().conf
                                      .MLY_STATES_DICTIONARY[
                                      this.props.data.dataPerBssid[0]
                                        .diagnostics.last_state
                                    ].color
                                  : "text-" +
                                    this.props.data.dataPerBssid[0].diagnostics
                                      .color
                              }
                            >
                              <h4>
                                {
                                  this.getAppContext().conf
                                    .MLY_STATES_DICTIONARY[
                                    this.props.data.dataPerBssid[0].diagnostics
                                      .last_state
                                  ].text
                                }{" "}
                                {this.props.data.dataPerBssid[0].diagnostics
                                  .err_step
                                  ? "(" +
                                    this.props.data.dataPerBssid[0].diagnostics.err_step.substring(
                                      3,
                                      this.props.data.dataPerBssid[0]
                                        .diagnostics.err_step.length
                                    ) +
                                    ")"
                                  : null}
                              </h4>
                              <div className="sub-title">
                                since{" "}
                                {this.props.data.dataPerBssid[0].diagnostics
                                  .last_state_ts
                                  ? this.getAppContext()
                                      .momentjs(
                                        this.props.data.dataPerBssid[0]
                                          .diagnostics.last_state_ts,
                                        "X"
                                      )
                                      .format("L LT")
                                  : "-"}
                              </div>
                            </span>
                          )
                        ) : (
                          <div
                            className={
                              "text-" +
                              this.getAppContext().conf.MLY_STATES_DICTIONARY[
                                "NA"
                              ].color
                            }
                          >
                            {
                              this.getAppContext().conf.MLY_STATES_DICTIONARY[
                                "NA"
                              ].text
                            }
                          </div>
                        )}
                      </div>
                    </div>
                  ) : null}
                  <div
                    className={
                      this.getAppContext().isCloud()
                        ? "d-flex flex-column p-3"
                        : "border-left border-gray300 d-flex flex-column p-3"
                    }
                  >
                    <small className="text-muted mb-2">
                      <strong>MEASURES</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center">
                      <h4 id="_mcount_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.measures_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_mcount_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>ERRORS</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center title-3">
                      <h4 id="_ecount_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.errors_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_ecount_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>SLOW MEASURES</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center title-3">
                      <h4 id="_o10count_not_available_info_">
                        {this.props.data.overalData.rrd_step == 60
                          ? this.props.data.overalData.over10_count
                          : "--"}
                        {this.props.data.overalData.rrd_step != 60 ? (
                          <span>
                            <ReactOTooltip
                              placement="bottom"
                              target="_o10count_not_available_info_"
                              text={
                                "Data not available for selected view range"
                              }
                            />
                            <span className="sub-title icon-info-outline ml-2" />
                          </span>
                        ) : null}
                      </h4>
                    </div>
                  </div>
                  <div className="d-flex flex-column p-3">
                    <small className="text-muted mb-2">
                      <strong>SCORE</strong>
                    </small>
                    <div className="d-flex h-100 align-items-center">
                      <h4
                        className={classnames({
                          "text-success":
                            this.props.data.overalData.score >= 80,
                          "text-orange":
                            this.props.data.overalData.score >= 60 &&
                            this.props.data.overalData.score < 80,
                          "text-danger": this.props.data.overalData.score < 60,
                        })}
                      >
                        {this.props.data.overalData.score !== undefined
                          ? this.props.data.overalData.score
                          : "--"}
                      </h4>
                    </div>
                  </div>
                </Section>
              </Col>
            </Row>
          ) : null}
        </Panel>

        {!/ethernet/i.test(this.props.data.essid) ? (
          <Panel
            className="mx-4 mb-2"
            bodyClassName="p-0"
            rounded
            header={
              <div>
                <div>BSSID LIST</div>
                <div
                  className={
                    !this.getAppContext().media.isMobile
                      ? "d-flex flex-grow-1"
                      : ""
                  }
                >
                  <small className="text-muted">
                    BSSIDs tested in selected time range given the current
                    measure configuration
                  </small>
                  {this.props.freqData &&
                    Object.keys(this.props.freqData).length > 1 && (
                      <div
                        style={
                          this.getAppContext().media.isMobile
                            ? { marginTop: "1em" }
                            : { marginTop: "-1em" }
                        }
                        className="ml-auto"
                      >
                        <ReactOActionBar padding="0">
                          <div style={{ marginTop: "0.2em" }} className="mr-3">
                            Show graphs:
                          </div>
                          <ButtonGroup>
                            <ReactOButton
                              size="sm"
                              className={
                                this.state.currFreq == "all"
                                  ? ""
                                  : "background-btn"
                              }
                              color={
                                this.state.currFreq == "all"
                                  ? "primary"
                                  : "light"
                              }
                              onClick={() => {
                                this.setState({
                                  currFreq: "all",
                                });
                              }}
                              // disabled={
                              //   this.state.data && this.state.data[0].sync_status == null
                              // }
                            >
                              <strong>
                                All (
                                {(this.props.freqData["2.4"] || 0) +
                                  (this.props.freqData["5"] || 0) +
                                  (this.props.freqData["6"] || 0)}
                                )
                              </strong>
                            </ReactOButton>
                            {this.props.freqData["2.4"] != null && (
                              <ReactOButton
                                size="sm"
                                className={
                                  this.state.currFreq == "2.4"
                                    ? ""
                                    : "background-btn"
                                }
                                color={
                                  this.state.currFreq == "2.4"
                                    ? "primary"
                                    : "light"
                                }
                                onClick={() => {
                                  this.setState({
                                    currFreq: "2.4",
                                  });
                                }}
                                // disabled={
                                //   this.state.data && this.state.data[0].sync_status == null
                                // }
                              >
                                <strong>
                                  2.4GHz ({this.props.freqData["2.4"]})
                                </strong>
                              </ReactOButton>
                            )}
                            {this.props.freqData["5"] != null && (
                              <ReactOButton
                                size="sm"
                                color={
                                  this.state.currFreq == "5"
                                    ? "primary"
                                    : "light"
                                }
                                className={
                                  this.state.currFreq == "5"
                                    ? ""
                                    : "background-btn"
                                }
                                onClick={() => {
                                  this.setState({
                                    currFreq: "5",
                                  });
                                }}
                                // disabled={
                                //   this.state.data && this.state.data[0].sync_status == null
                                // }
                              >
                                <strong>
                                  5GHz ({this.props.freqData["5"]})
                                </strong>
                              </ReactOButton>
                            )}
                            {this.props.freqData["6"] != null && (
                              <ReactOButton
                                size="sm"
                                color={
                                  this.state.currFreq == "6"
                                    ? "primary"
                                    : "light"
                                }
                                className={
                                  this.state.currFreq == "6"
                                    ? ""
                                    : "background-btn"
                                }
                                onClick={() => {
                                  this.setState({
                                    currFreq: "6",
                                  });
                                }}
                              >
                                <strong>
                                  6GHz ({this.props.freqData["6"]})
                                </strong>
                              </ReactOButton>
                            )}
                          </ButtonGroup>
                        </ReactOActionBar>
                      </div>
                    )}
                </div>
              </div>
            }
          >
            <ReactOTable
              thClassName="px-3 py-1"
              tdClassName="align-middle px-3 py-1"
              hoverable
              compressed={
                this.getAppContext().media.isMobile ||
                this.getAppContext().media.isTablet
              }
              compressedRowRendering={(row_items, link) => {
                return link ? (
                  <div>
                    <Link className="link-table-test" to={link} target="_blank">
                      <div className="text-center">
                        {row_items.graph_image.content}
                      </div>
                      <div className="mt-2">{row_items.bssid.content}</div>
                      <div className="mt-2">
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.status.title}</strong>
                          </small>
                        </div>
                        {row_items.status.content}
                      </div>
                      <Row className="mt-2">
                        <Col>
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.rssi.title}</strong>
                            </small>
                          </div>
                          {row_items.rssi.content}
                        </Col>
                        <Col>
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.score.title}</strong>
                            </small>
                          </div>
                          {row_items.score.content}
                        </Col>
                      </Row>
                    </Link>
                  </div>
                ) : (
                  <div>
                    <div className="text-center">
                      {row_items.graph_image.content}
                    </div>
                    <div className="mt-2">{row_items.bssid.content}</div>
                    <div className="mt-2">
                      <div className="text-muted">
                        <small className="">
                          <strong>{row_items.status.title}</strong>
                        </small>
                      </div>
                      {row_items.status.content}
                    </div>
                    <Row className="mt-2">
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.rssi.title}</strong>
                          </small>
                        </div>
                        {row_items.rssi.content}
                      </Col>
                      <Col>
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.score.title}</strong>
                          </small>
                        </div>
                        {row_items.score.content}
                      </Col>
                    </Row>
                  </div>
                );
              }}
              thDividers
              defaultSort={[
                {
                  data_key: "status",
                  order: "desc",
                },
                {
                  data_key: "score",
                  order: "desc",
                },
                {
                  data_key: "rssi",
                  order: "desc",
                },
                {
                  constrain: "down",
                  data_key: "rssi",
                  func: (value) => {
                    return value == 0;
                  },
                },
              ]}
              onRowClick={
                this.props.onItemClick
                  ? this.props.onItemClick
                  : (row_data) => {
                      console.log(row_data);
                    }
              }
              cols={[
                {
                  title: "GRAPH",
                  //	align: 'center',
                  data_key: "graph_image",
                  width: "15",
                },
                {
                  title: "BSSID",
                  align: "center",
                  data_key: "bssid",
                  width: "25",
                  sortable: true,
                },
                //	{
                //		title: "FREQUENCY",
                //		align: 'center',
                //		data_key: 'frequency',
                //		width: '15',
                //		sortable: true
                //	},
                {
                  title: (
                    <span>
                      <span className="icon-wifi mr-2" />
                      RSSI
                    </span>
                  ),
                  align: "center",
                  data_key: "rssi",
                  width: "10",
                  sortable: true,
                },
                ...(this.getAppContext().isCloud()
                  ? [
                      {
                        title: "DIAGNOSTICS",
                        align: "center",
                        data_key: "status",
                        width: "15",
                        sortable: true,
                      },
                    ]
                  : []),
                {
                  title: "SCORE",
                  align: "center",
                  data_key: "score",
                  width: "10",
                  sortable: true,
                },
              ]}
              rows={(() => {
                let _TMP = (
                  this.props.data.dataPerBssid
                    ? this.props.data.dataPerBssid
                    : []
                )
                  .sort()
                  .filter((elem) => {
                    if (
                      elem.last_freq &&
                      Object.keys(elem.last_freq).length > 0
                    ) {
                      if (this.state.currFreq == "2.4") {
                        return elem.last_freq.curr_f < 5000;
                      } else if (this.state.currFreq == "5") {
                        return (
                          elem.last_freq.curr_f > 5000 &&
                          elem.last_freq.curr_f < 5925
                        );
                      } else if (this.state.currFreq == "6") {
                        return elem.last_freq.curr_f >= 5925;
                      } else {
                        return elem.last_freq.curr_f > 0;
                      }
                    } else {
                      return elem;
                    }
                  })
                  .map((_CURR_measure, _CURR_idx) => {
                    const _vp = this.props.viewrange.view_preset;
                    const _hasValidPreset =
                      _vp !== undefined &&
                      _vp !== null &&
                      _vp !== "no" &&
                      this.props.viewrange.is_preset == "yes";
                    return {
                      _link:
                        "/" +
                        this.props.match.params.probeuid +
                        "/" +
                        this.props.match.params.status +
                        "/" +
                        this.props.data.cssid +
                        "/" +
                        _CURR_measure.bssid.replace(/:/g, "") +
                        (_hasValidPreset ? "/" + _vp : ""),
                      cssid: this.props.data.cssid,
                      bssid: {
                        value: _CURR_measure.bssid,
                        render: (
                          <div className="d-flex align-items-center">
                            <div className="flex-grow-1">
                              {_CURR_measure.bssid_info ? (
                                <Row>
                                  <Col xs={12}>
                                    {_CURR_measure.bssid_info.ap_custom_data ? (
                                      (() => {
                                        let _tooltip_id = _CURR_measure
                                          .bssid_info.ap_custom_data.mac_lan
                                          ? "_ap_cst_" +
                                            _CURR_measure.bssid.replace(
                                              /:/g,
                                              ""
                                            ) +
                                            "_" +
                                            _CURR_measure.bssid_info.ap_custom_data.mac_lan.replace(
                                              /:/g,
                                              ""
                                            )
                                          : null;
                                        return (
                                          <span id={_tooltip_id}>
                                            {_CURR_measure.bssid_info
                                              .ap_custom_data.mac_lan ? (
                                              <ReactOTooltip
                                                placement="bottom"
                                                target={_tooltip_id}
                                                text={
                                                  "LAN mac address: " +
                                                  _CURR_measure.bssid_info
                                                    .ap_custom_data.mac_lan
                                                }
                                              />
                                            ) : null}
                                            <h4>
                                              {_CURR_measure.bssid_info
                                                .ap_custom_data.name +
                                                (_CURR_measure.bssid_info
                                                  .ap_custom_data.ip == ""
                                                  ? ""
                                                  : " - " +
                                                    _CURR_measure.bssid_info
                                                      .ap_custom_data.ip)}
                                            </h4>
                                          </span>
                                        );
                                      })()
                                    ) : (
                                      <h4>{_CURR_measure.bssid}</h4>
                                      // <span>{_CURR_measure.bssid_info.long_desc}</span>
                                    )}
                                  </Col>
                                </Row>
                              ) : null}

                              {_CURR_measure.bssid_info.ap_custom_data ? (
                                <Row>
                                  <Col xs={12}>
                                    <span className="sub-title">
                                      {_CURR_measure.bssid}
                                    </span>
                                  </Col>
                                </Row>
                              ) : _CURR_measure.bssid_info.long_desc ? (
                                <span className="sub-title">
                                  {_CURR_measure.bssid_info.long_desc}
                                </span>
                              ) : null}
                            </div>
                            <div
                              className="align-self-start"
                              style={{ width: "48px" }}
                            >
                              {this.getAppContext().freqToLabel(
                                _CURR_measure.last_freq
                              )}
                            </div>
                          </div>
                        ),
                      },
                      graph_image: (
                        <img
                          src={
                            this.getAppContext()
                              .getApiStoreService()
                              .getCluster() +
                            "/RRDgrcache/" +
                            _CURR_measure.ImgName
                          }
                          className="border border-1 rounded"
                          alt="graph"
                        />
                      ),
                      //	bssid_count: _CURR_measure.dataPerBssid.length,
                      score: {
                        value: _CURR_measure.score,
                        render: (
                          <span
                            className={classnames({
                              "text-success": _CURR_measure.score >= 80,
                              "text-orange":
                                _CURR_measure.score >= 60 &&
                                _CURR_measure.score < 80,
                              "text-danger": _CURR_measure.score < 60,
                            })}
                          >
                            {_CURR_measure.score}
                          </span>
                        ),
                      },
                      rssi: {
                        value: _CURR_measure.rssi,
                        render: (
                          <span
                            className={classnames({
                              "": _CURR_measure.rssi == 0,
                              "text-success":
                                _CURR_measure.rssi >= -60 &&
                                _CURR_measure.rssi != 0,
                              "text-orange":
                                _CURR_measure.rssi >= -74 &&
                                _CURR_measure.rssi < -60 &&
                                _CURR_measure.rssi != 0,
                              "text-danger":
                                _CURR_measure.rssi < -74 &&
                                _CURR_measure.rssi != 0,
                            })}
                          >
                            <h4>
                              {_CURR_measure.rssi == 0
                                ? "--"
                                : _CURR_measure.rssi + " dBm"}
                            </h4>

                            {_CURR_measure.rssi == 0 ? null : (
                              <div
                                className={classnames({
                                  "sub-title":
                                    _CURR_measure.overlap >= 0 &&
                                    _CURR_measure.overlap < 5,
                                  "sub-title text-orange":
                                    _CURR_measure.overlap > 4 &&
                                    _CURR_measure.overlap < 9,
                                  "sub-title text-danger":
                                    _CURR_measure.overlap > 9,
                                })}
                              >
                                Overlap idx: {_CURR_measure.overlap}
                              </div>
                            )}
                          </span>
                        ),
                      },
                      ...(this.getAppContext().isCloud()
                        ? {
                            status: _CURR_measure.diagnostics.last_state
                              ? {
                                  value:
                                    this.getAppContext().conf
                                      .MLY_STATES_DICTIONARY[
                                      _CURR_measure.diagnostics.last_state
                                    ].value,
                                  render: (
                                    <div id={"tp-" + _CURR_idx + "-diag"}>
                                      <span
                                        className={
                                          _CURR_measure.diagnostics
                                            .last_state == "N" ||
                                          _CURR_measure.diagnostics
                                            .last_state == "U"
                                            ? "text-" +
                                              this.getAppContext().conf
                                                .MLY_STATES_DICTIONARY[
                                                _CURR_measure.diagnostics
                                                  .last_state
                                              ].color
                                            : "text-" +
                                              _CURR_measure.diagnostics.color
                                        }
                                      >
                                        {_CURR_measure.diagnostics.err_step &&
                                        _CURR_measure.diagnostics.err_step
                                          .length > 0 ? (
                                          <ReactOTooltip
                                            placement="bottom"
                                            target={"tp-" + _CURR_idx + "-diag"}
                                            text={
                                              <div>
                                                {this.getAppContext().getDiag(
                                                  _CURR_measure.diagnostics
                                                    .last_state,
                                                  _CURR_measure.diagnostics
                                                    .consideration
                                                )}
                                                {this.getAppContext().getErrWording(
                                                  _CURR_measure.diagnostics
                                                    .err_step
                                                )}
                                                {/* {_CURR_measure.diagnostics.err_step.substring(
                                                  0,
                                                  2
                                                ) == "MO"
                                                  ? " mostly on " +
                                                    _CURR_measure.diagnostics.err_step.substring(
                                                      3,
                                                      _CURR_measure.diagnostics.err_step
                                                        .length
                                                    )
                                                  : " on " +
                                                    _CURR_measure.diagnostics.err_step.substring(
                                                      3,
                                                      _CURR_measure.diagnostics.err_step
                                                        .length
                                                    )} */}
                                                <div>
                                                  {_CURR_measure.diagnostics
                                                    .term &&
                                                  _CURR_measure.diagnostics
                                                    .term == 2
                                                    ? " (previous 4h)"
                                                    : " (last period)"}
                                                </div>
                                              </div>
                                            }
                                          />
                                        ) : null}
                                        <h4>
                                          {this.getAppContext().getDiag(
                                            _CURR_measure.diagnostics
                                              .last_state,
                                            _CURR_measure.diagnostics
                                              .consideration
                                          )}{" "}
                                          {_CURR_measure.diagnostics.err_step &&
                                          _CURR_measure.diagnostics.err_step
                                            .length > 0
                                            ? this.parseErr(
                                                _CURR_measure.diagnostics
                                                  .err_step
                                              )
                                            : null}
                                        </h4>
                                        <div className="sub-title">
                                          since{" "}
                                          {_CURR_measure.diagnostics
                                            .last_state_ts
                                            ? this.getAppContext()
                                                .momentjs(
                                                  _CURR_measure.diagnostics
                                                    .last_state_ts,
                                                  "X"
                                                )
                                                .format("L LT")
                                            : "-"}
                                        </div>
                                      </span>
                                    </div>
                                  ),
                                }
                              : {
                                  value:
                                    this.getAppContext().conf
                                      .MLY_STATES_DICTIONARY["NA"].value,
                                  render: (
                                    <div
                                      className={
                                        "text-" +
                                        this.getAppContext().conf
                                          .MLY_STATES_DICTIONARY["NA"].color
                                      }
                                    >
                                      {
                                        this.getAppContext().conf
                                          .MLY_STATES_DICTIONARY["NA"].text
                                      }
                                    </div>
                                  ),
                                },
                          }
                        : {}),
                    };
                  });
                return _TMP;
              })()}
            />
          </Panel>
        ) : null}
        {this.props.data.dataPerBssid &&
        this.props.data.dataPerBssid.length == 1 &&
        !/ethernet/i.test(this.props.data.essid) ? (
          <small className="mx-4 mb-4 text-muted d-flex align-items-center">
            <span className="icon-info mr-1" style={{ fontSize: "130%" }} />A
            single access point was tested for the given measure criteria and
            period
          </small>
        ) : null}
      </div>
    ) : null;
  }
}

export default contextProvider(
  withRouter(MeasureBssidsList),
  //	withDefinedContext(MeasureBssidsList, 'MeasureBssidsList', context_exposed_methods),
  {
    define: null,
  }
);
